import { useAnimatedCounter } from "@/hooks/useAnimatedCounter";
import { cn } from "@/lib/utils";

interface AnimatedCounterProps {
  value: number;
  suffix?: string;
  className?: string;
  decimals?: number;
  duration?: number;
}

export const AnimatedCounter = ({ 
  value, 
  suffix = "", 
  className,
  decimals = 1,
  duration = 1500
}: AnimatedCounterProps) => {
  const { count, ref } = useAnimatedCounter({ 
    end: value, 
    duration,
    decimals 
  });

  return (
    <span ref={ref} className={cn("tabular-nums", className)}>
      {count}{suffix}
    </span>
  );
};
